import type { NotificationsSlice } from '../bs/notifications'

/**
 * English for the notification centre, the bell's panel and the preferences
 * card.
 *
 * Complete, not partial — see en/index.ts. "Report" for *prijava*, as
 * everywhere else, and "reminders" for *podsjetnici*.
 */
export const notifications: NotificationsSlice = {
  'notifications.high.one': '{count} urgent',
  'notifications.high.few': '{count} urgent',
  'notifications.high.many': '{count} urgent',

  'notifications.open': 'Open',
  'notifications.markRead': 'Mark as read',
  'notifications.delete': 'Delete notification',
  'notifications.deleted': 'Notification deleted.',
  'notifications.failed': 'That did not work. Please try again.',
  'notifications.importance.high': 'Urgent',

  'notifications.viewAll': 'All notifications',
  'notifications.settings': 'Notification settings',

  'notifications.page.subtitle': 'Everything the app has told you, day by day.',
  'notifications.filter.label': 'Kind of notification',
  'notifications.filter.sve': 'All',
  'notifications.filter.prijave': 'Reports',
  'notifications.filter.zadaci': 'Tasks',
  'notifications.filter.5s': '5S',
  'notifications.filter.podsjetnici': 'Reminders',
  'notifications.filter.sazetak': 'Summary',
  'notifications.unreadOnly': 'Unread only',
  'notifications.loadMore': 'Load more',
  'notifications.shown': 'Showing {shown} of {total}',

  'notifications.empty.sve.title': 'No notifications yet',
  'notifications.empty.sve':
    'Urgent reports, changes to your reports, tasks assigned to you and reminders about anything overdue arrive here.',
  'notifications.empty.unread': 'You will see anything new here and on the bell.',
  'notifications.empty.filter.title': 'Nothing of this kind',
  'notifications.empty.prijave':
    'Urgent reports, status changes on your reports and reviews of your suggestions arrive here.',
  'notifications.empty.zadaci': 'Tasks assigned to you arrive here.',
  'notifications.empty.5s':
    'A reminder arrives here when machines in your plants have no 5S evaluation yet this month.',
  'notifications.empty.podsjetnici':
    'The morning round-up of tasks and reports past their deadline arrives here.',
  'notifications.empty.sazetak': 'The daily summary arrives here, if you turn it on in settings.',
  'notifications.choose': 'Choose what you get',

  'notifications.prefs.title': 'Notifications',
  'notifications.prefs.intro': 'Choose what you get and where. Each change is saved at once.',
  'notifications.prefs.type': 'Kind',
  'notifications.prefs.app': 'In the app',
  'notifications.prefs.mail': 'E-mail',
  'notifications.prefs.switch': '{type}: {channel}',
  'notifications.prefs.noEmail': 'To get e-mail, first add your address under “Contact”.',
  'notifications.prefs.dailySummary':
    'Every morning at 7: what is new and what is overdue in your plants — only when there is something to say.',
  'notifications.prefs.saved': 'Saved: {type}',
  'notifications.prefs.failed': 'The change was not saved. Please try again.',
  'notifications.prefs.none': 'There are no notifications to set up for your role.',
}
